import React from 'react';
import { motion } from 'framer-motion';
export function WhyOtherSolutionsFail() {
  const solutions = [{
    solution: 'Buscar en Google',
    reason: 'Resultados contradictorios, alarmistas o demasiado técnicos'
  }, {
    solution: 'Foros y grupos',
    reason: 'Consejos sin respaldo médico disfrazados de experiencia'
  }, {
    solution: 'Remedios caseros',
    reason: 'Pueden irritar más o enmascarar síntomas importantes'
  }, {
    solution: 'Automedicación repetida',
    reason: 'Sin diagnóstico correcto, puede ser inútil o perjudicial'
  }, {
    solution: 'Consulta médica rápida',
    reason: 'Poco tiempo, poca explicación, muchas dudas sin resolver'
  }];
  return <section className="py-16 md:py-24 px-4 bg-bg-primary" data-id="element-338">
      <div className="max-w-5xl mx-auto" data-id="element-339">
        <motion.h2 className="font-heading text-3xl md:text-4xl font-bold text-heading mb-12 text-center" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-340">
          Por qué las soluciones habituales no son suficientes
        </motion.h2>

        <motion.div className="overflow-x-auto rounded-2xl shadow-lg" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} data-id="element-341">
          <table className="w-full bg-white" data-id="element-342">
            <thead data-id="element-343">
              <tr className="bg-accent-lilac" data-id="element-344">
                <th className="px-6 py-4 text-left font-heading text-lg text-heading" data-id="element-345">
                  Solución común
                </th>
                <th className="px-6 py-4 text-left font-heading text-lg text-heading" data-id="element-346">
                  Por qué falla
                </th>
              </tr>
            </thead>
            <tbody data-id="element-347">
              {solutions.map((item, index) => <tr key={index} className="border-b border-gray-100 hover:bg-gray-50 transition-colors" data-id="element-348">
                  <td className="px-6 py-4 font-semibold text-body" data-id="element-349">
                    {item.solution}
                  </td>
                  <td className="px-6 py-4 text-body" data-id="element-350">{item.reason}</td>
                </tr>)}
            </tbody>
          </table>
        </motion.div>

        <motion.p className="text-center text-xl font-bold text-heading mt-10" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} data-id="element-351">
          Lo que todas esas opciones tienen en común: ninguna te da el panorama
          completo. Esta guía sí lo hace.
        </motion.p>
      </div>
    </section>;
}